<div class="checkout-result w-full min-h-screen flex align-items-center justify-content-center p-4 mt-6">
  <div class="card p-5 border-round-xl bg-white shadow-2 w-full" style="max-width: 560px;">
    <div class="flex flex-column align-items-center text-center gap-3">
      <i [class]="icon + ' ' + iconClass" style="font-size: 3.5rem;"></i>
      <h1 class="font-prata text-3xl m-0">{{ title }}</h1>
      <p class="text-600 m-0 line-height-3">{{ message }}</p>
      <p *ngIf="errorMessage" class="text-red-500 text-sm m-0">{{ errorMessage }}</p>

      <div class="w-full mt-2 p-3 border-round-lg bg-gray-50 border-1 border-gray-100 text-left" *ngIf="orderId || paymentId">
        <div class="text-sm text-700" *ngIf="orderId"><strong>Pedido:</strong> #{{ orderId }}</div>
        <div class="text-sm text-700 mt-1" *ngIf="status?.totalAmount"><strong>Total:</strong> S/ {{ status?.totalAmount | number:'1.2-2' }}</div>
        <div class="text-sm text-700 mt-1" *ngIf="paymentId"><strong>Pago MP:</strong> {{ paymentId }}</div>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full mt-3" *ngIf="kind === 'approved'">
        <a pButton routerLink="/shop" label="Seguir comprando" class="p-button-outlined flex-1 border-round-lg"></a>
        <a pButton routerLink="/profile" label="Ver mi pedido" class="flex-1 border-round-lg"></a>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full mt-3" *ngIf="kind === 'failed'">
        <button *ngIf="canRetry" pButton type="button" label="Reintentar pago" icon="pi pi-refresh"
                class="p-button-danger flex-1 border-round-lg" [loading]="isRetrying" (click)="retryPayment()"></button>
        <a pButton routerLink="/checkout" label="Volver al checkout" class="p-button-outlined flex-1 border-round-lg"></a>
      </div>

      <div class="flex flex-column md:flex-row gap-2 w-full mt-3" *ngIf="kind === 'pending'">
        <button *ngIf="timedOut" pButton type="button" label="Volver a verificar" icon="pi pi-sync"
                class="flex-1 border-round-lg" (click)="startPolling()"></button>
        <a pButton routerLink="/profile" label="Ver mis pedidos" class="p-button-outlined flex-1 border-round-lg"></a>
      </div>
    </div>
  </div>
</div>
